import React, { forwardRef } from "react";
import { Control } from "react-hook-form";

import TextareaBase, { TextareaProps } from "./TextareaBase";
import TextareaControlled from "./TextareaControlled";

interface DynamicTextareaProps extends TextareaProps {
  control?: Control<any>;
}

const Textarea = forwardRef<HTMLTextAreaElement, DynamicTextareaProps>(function Textarea(args, ref) {
  return args?.control ? <TextareaControlled control={args.control} {...args} /> : <TextareaBase {...args} ref={ref} />;
});

export default Textarea;
